import * as React from 'react';
import './GroupSettingsLayout.scss';
import { connect } from "react-redux";
import { RestrictedLayout } from "../../../components/layouts/index";
import { ITmdState } from "../../../reducers/index";
import * as Dtos from '../../../dtos/Tmd.dtos';
import { SettingsSubMenu } from '../../../helpers/subMenuHelper';
import * as AuthenticationHelper from '../../../helpers/authentication';
import { FontAwesomeIcon, FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";

interface IGroupSettingsLayoutProps {
    permissions?: Dtos.PersonnelTmdPermissions[];
    permission?: Dtos.Permission;
    loading?: boolean;
    children?: any;
}

interface IGroupSettingsLayoutActions {

}

type GroupSettingsLayoutProps = IGroupSettingsLayoutProps & IGroupSettingsLayoutActions;

class GroupSettingsLayout extends React.PureComponent<GroupSettingsLayoutProps, any> {

    constructor(props: GroupSettingsLayoutProps) {
        super(props);

    }

    render() {
        const {
            loading,
            permissions,
            permission
        } = this.props;

        let menu: any = []; 
        if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.GroupItemTemplatesView)) {
            menu.push({
                icon: undefined,
                title: "Item Templates",
                url: "/settings/group/itemtemplates"
            });
        }
        if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.GroupItemComponentsView)) {
            menu.push({
                icon: undefined,
                title: "Item Components",
                url: "/settings/group/itemcomponents"
            });
        }
        if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.GroupItemCategoriesView)) {
            menu.push({
                icon: undefined,
                title: "Item Categories",
                url: "/settings/group/itemcategories"
            });
        }

        return <RestrictedLayout
            subMenuItems={loading ? [] : SettingsSubMenu(permissions)}
            sub2MenuItems={loading ? [] : menu}
            loading={loading}
        >
            {permissions.length > 0 && permission && !AuthenticationHelper.hasPermission(permissions, permission) ?
                <div className="alert alert-warning d-flex">
                    <div className="mr-2">
                        <FontAwesomeIcon icon={FontAwesomeIcons.Solid.INFO_SQUARE} fixedWidth />
                    </div>
                    <span>Permission Denied</span>
                </div>
                : this.props.children}
        </RestrictedLayout>;
    }

}


const mapStateToProps = (state: ITmdState, ownProps: GroupSettingsLayoutProps): IGroupSettingsLayoutProps => {
    let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];
    return {
        permissions: permissions,
        permission: ownProps.permission,
        loading: ownProps.loading,
        children: ownProps.children
    };
};

const mapDispatchToProps = (dispatch): IGroupSettingsLayoutActions => {
    return {
        
    };
};

export default
    connect(mapStateToProps, mapDispatchToProps)(GroupSettingsLayout);
